// extracted by mini-css-extract-plugin
export var section = "news-single-header-module--section--My2Jr";